export default "/dist/files/icone_indispensables.7c23b675665c6938e39bd1e1b1484bf2.svg";